module.exports = __webpack_public_path__ + "static/infographic-768733cbdfbdbfff69cba209e5f68868.jpg";